const ROWS = 200;

/**
 * Feeds the revoke-permission confirmation's preview: every user currently carrying the role whose
 * permission is about to change. Fixed page size, never exposed as something a caller could vary.
 */
class FetchRoleImpactedUsers {
	constructor(
		public readonly accountId: number,
		public readonly roleId: number,
	) {
		Object.freeze(this);
	}

	get queryParams(): URLSearchParams {
		const params = new URLSearchParams();
		params.set('roleId', String(this.roleId));
		params.set('rows', String(ROWS));
		return params;
	}
}

export default FetchRoleImpactedUsers;
